module.exports = __webpack_public_path__ + "static/media/message-bubble-left.bde6ca37.svg";